import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import React, { useEffect } from "react";
import DefaultSortProvider from "contexts/defaultSortContext";
import "./_i18n/i18n";
import AppRouter from "./routing/AppRouter";
import store from "./store/store";
import { setupDemoAuth } from "./demo/demoAuth";
import "react-toastify/dist/ReactToastify.css";
import AllConversationsProvider from "contexts/allConversationsContext";
import AcademyBranchesProvider from "contexts/academyBranchesContext";
import NavbarProvider from "contexts/navbarContext";

function App() {
  useEffect(() => {
    setupDemoAuth();
  }, []);

  return (
    // @ts-ignore
    <Provider store={store}>
      <DefaultSortProvider>
        <AcademyBranchesProvider>
          <NavbarProvider>
            <Router>
              <AllConversationsProvider>
                <AppRouter />
              </AllConversationsProvider>
            </Router>
            <ToastContainer />
          </NavbarProvider>
        </AcademyBranchesProvider>
      </DefaultSortProvider>
    </Provider>
  );
}

export default App;
